import { getFirestore, collection, documentId, getDocs, query, where } from "firebase/firestore";
import { app } from "../firebase";

const CATALOGUE_COLLECTION = "catalogueItems";
const productsByTemplateId = new Map();

/**
 * Loads a starter template's products from the live catalogue, in the template's order.
 * Products that no longer exist are left out; throws if none of them can be loaded.
 */
export const fetchStarterProducts = async (template) => {
	if (productsByTemplateId.has(template.id)) return productsByTemplateId.get(template.id);

	const productsQuery = query(collection(getFirestore(app), CATALOGUE_COLLECTION), where(documentId(), "in", template.productIds));
	const snapshot = await getDocs(productsQuery);
	const productsById = Object.fromEntries(snapshot.docs.map((productDoc) => [productDoc.id, { id: productDoc.id, ...productDoc.data() }]));
	const products = template.productIds.map((productId) => productsById[productId]).filter(Boolean);

	if (products.length === 0) throw new Error(`No catalogue products found for starter "${template.id}"`);
	productsByTemplateId.set(template.id, products);
	return products;
};
